import { computed } from 'vue'
import i18n from '../../locales/i18n'
import type { SelectorObject } from '../components/SelectorObject'

export enum EStatus {
    DISABLED = 0,
    ENABLED = 1
}

export const EStatusLabels = {
    [EStatus.DISABLED]: 'enum.status.disabled',
    [EStatus.ENABLED]: 'enum.status.enabled'
}

export enum EPresenceStatus {
    ALL = 0,
    PENDING = 'pending',
    VALIDATED = 'validated'
}

export const EPresenceStatusValues = [
    EPresenceStatus.ALL,
    EPresenceStatus.PENDING,
    EPresenceStatus.VALIDATED
]

export const EPresenceStatusLabels = {
    [EPresenceStatus.ALL]: 'enum.status.all',
    [EPresenceStatus.PENDING]: 'enum.status.pending',
    [EPresenceStatus.VALIDATED]: 'enum.status.validated'
}

export const EPresenceStatusOptions = computed<SelectorObject[]>(() =>
    EPresenceStatusValues.map(value => ({
        label: i18n.global.t(EPresenceStatusLabels[value]),
        value
    }))
)
